export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const SERVICES_LOADING = "SERVICES_LOADING";
export const SET_SERVICE = "SET_SERVICE";
export const GET_SERVICE_DETAILS_SUCCESS = "GET_SERVICE_DETAILS_SUCCESS";
export const GET_SCROLL_SERVICES_SUCCESS = "GET_SCROLL_SERVICES_SUCCESS";
